/* =========================================================
   MM Product Card - Slider images (grille produits)
   - Scroll-snap natif (swipe mobile fluide, zero instance par carte)
   - Navigation par INDEX (chaque clic = image suivante, fiable meme en pleine animation)
   - Aucun changement d'image au survol (demande cliente du 2026-10-01)
   - Reinitialise les cartes ajoutees par l'infinite scroll (mm:products-loaded)

   Sept. 2026 : les puces (facon sezane.com) sont construites ici plutot
   que dans le Liquid, pour que toutes les cartes du site en profitent
   sans toucher au snippet. Elles ne sont visibles qu'en mobile (CSS) et
   ne sont creees que s'il y a plus d'une image.
   ========================================================= */
(function () {
	'use strict';

	function initSlider(slider) {
		if (!slider || slider.dataset.mmSliderInit === '1') return;
		slider.dataset.mmSliderInit = '1';

		var track = slider.querySelector('[data-mm-track]');
		if (!track) return;
		var prev = slider.querySelector('[data-mm-arrow="prev"]');
		var next = slider.querySelector('[data-mm-arrow="next"]');
		var count = track.children.length;

		// Index logique : la source de verite pour la navigation par fleches.
		// Immunise contre les lectures de scrollLeft pendant une animation en cours.
		var index = 0;

		// --- Puces -------------------------------------------------------
		var dots = null;
		if (count > 1) {
			dots = document.createElement('div');
			dots.className = 'mm-pc-dots';
			dots.setAttribute('aria-hidden', 'true');

			for (var d = 0; d < count; d++) {
				var dot = document.createElement('button');
				dot.type = 'button';
				dot.className = 'mm-pc-dot' + (d === 0 ? ' is-active' : '');
				dot.setAttribute('tabindex', '-1');
				dot.dataset.mmDot = String(d);
				dots.appendChild(dot);
			}

			dots.addEventListener('click', function (e) {
				var target = e.target.closest ? e.target.closest('[data-mm-dot]') : null;
				if (!target) return;
				// La carte entiere est un lien : on neutralise la navigation.
				e.preventDefault();
				e.stopPropagation();
				goTo(parseInt(target.dataset.mmDot, 10) || 0);
			});

			slider.appendChild(dots);
		}

		function slideWidth() {
			return track.clientWidth || (track.firstElementChild ? track.firstElementChild.clientWidth : 0);
		}

		function updateArrows() {
			if (prev) prev.classList.toggle('mm-pc-arrow-hidden', index <= 0);
			if (next) next.classList.toggle('mm-pc-arrow-hidden', index >= count - 1);
			if (dots) {
				for (var i = 0; i < dots.children.length; i++) {
					dots.children[i].classList.toggle('is-active', i === index);
				}
			}
		}

		function goTo(i) {
			index = Math.max(0, Math.min(i, count - 1));
			track.scrollTo({ left: index * slideWidth(), behavior: 'smooth' });
			updateArrows();
		}

		if (prev) {
			prev.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				goTo(index - 1);
			});
		}
		if (next) {
			next.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				goTo(index + 1);
			});
		}

		// Apres un swipe (scroll utilisateur), on resynchronise l'index une fois le defilement stabilise.
		// Le debounce evite d'ecraser l'index pendant une rafale de clics ou une animation.
		var settle = null;
		track.addEventListener('scroll', function () {
			if (settle) clearTimeout(settle);
			settle = setTimeout(function () {
				var w = slideWidth();
				if (w) {
					index = Math.round(track.scrollLeft / w);
					updateArrows();
				}
			}, 90);
		}, { passive: true });

		/* [2026-10-01] Plus aucun changement d'image au survol sur ordinateur.
		   La carte faisait glisser la piste jusqu'a la 2e photo a l'entree de la
		   souris et revenait a la premiere a la sortie : la cliente a demande que
		   les photos ne bougent plus toutes seules au passage de la souris.
		   Les fleches, elles, restent revelees au survol (mm-card-slider.css) :
		   feuilleter les images reste possible, mais a la main. Le balayage
		   tactile et les puces mobiles ne sont pas concernes. */

		updateArrows();
	}

	function initAll(root) {
		var scope = (root && root.querySelectorAll) ? root : document;
		var sliders = scope.querySelectorAll('[data-mm-slider]');
		for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
	}

	function ready() {
		initAll(document);
	}

	if (!window.__mmCardSliderBound) {
		window.__mmCardSliderBound = true;
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', ready);
		} else {
			ready();
		}
		// Produits ajoutes via l'infinite scroll de la grille
		document.addEventListener('mm:products-loaded', function (e) {
			initAll(e && e.detail && e.detail.container ? e.detail.container : document);
		});
	} else {
		ready();
	}
})();
